import React from 'react';
import { useState, useEffect } from 'react';
import barChart from '../../../../assets/icons/bar-chart-square-02.png';
import arrow from '../../../../assets/icons/arrow-up.png';
import search_icon from '../../../../assets/icons/search_icon.png';
import plus from '../../../../assets/icons/plus.png';
import { Table } from 'antd';
import './style.css';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  Form,
  Input,
  Button,
  Row,
  Col,
  Steps,
  Upload,
  message,
  Select,
  Space,
} from 'antd';
import DashboardTable from '../dashboardTable/index.js';
import step_base_icon from '../../../../assets/icons/step_base_icon.png';
import edit_icon from '../../../../assets/icons/edit_icon.png';
import view_icon from '../../../../assets/icons/view_icon.png';
import download_icon from '../../../../assets/icons/download_icon.png';
import arrow_down from '../../../../assets/icons/arrow_down.png';
import {
  getProjectList,
  createBbs,
  getBbsList,
  getProjectCount,
} from '../../redux/slice.js';
import { useSelector, useDispatch } from 'react-redux';

const { Step } = Steps;

const CreateBBSPage = ({ onReturnToDashboard }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Option } = Select;

  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});

  const [currentStep, setCurrentStep] = useState(0);

  const [isStepperFormVisible, setIsStepperFormVisible] = useState(false);

  const [selectedLocationName, setSelectedLocationName] = useState('');
  const [selectedProjectName, setSelectedProjectName] = useState(null);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [isSingleProjectCode, setIsSingleProjectCode] = useState(false);


  // const handleProjectNameChange = (value) => {
  //     setSelectedProjectName(value);
  // };
  const handleProjectNameChange = (value) => {
    const matchingProjects = allProjectList.filter(
      (item) => item.project_name === value,
    );

    console.log('Matching Projects:', matchingProjects);

    if (matchingProjects.length === 1) {
      form.setFieldsValue({ project_id: matchingProjects[0].id });
      setIsSingleProjectCode(true);
    } else {
      form.setFieldsValue({ project_id: undefined });
      setIsSingleProjectCode(false);
    }

    setSelectedProjectName(value);
    setFilteredProjects(matchingProjects);
  };

  const { allProjectList, bbsList, projectCount } = useSelector(
    (state) => state.projectList,
  );
  useEffect(() => {
    dispatch(getProjectList());
  }, [dispatch]);


  useEffect(() => {
    dispatch(getBbsList());
  }, [dispatch]);

  console.log(
    'All Project list: ',
    allProjectList,
    'Type:',
    Array.isArray(allProjectList),
  );

  console.log('All Bbs list: ', bbsList, 'Type:', Array.isArray(bbsList));

  const nextStep = () => {
    form
      .validateFields()
      .then((values) => {
        const payload = {
          project_id: Number(values?.project_id),
          sbg_id: values?.sbg_id,
          //location_id: values?.location_id,
          sbu_id: values?.sbu_id,
        };
        console.log('Payload:', payload);
        dispatch(createBbs(payload))
          .then((response) => {
            if (response?.payload?.success) {
              message.success(response?.payload?.message);
              getProjectList();
              getBbsList();
            } else {
              message.error(response?.payload?.message);
            }
            setFormData((prevData) => {
              const updatedData = { ...prevData, ...values };
              console.log('Updated data:', updatedData);
              return updatedData;
            });

            setIsStepperFormVisible(false);
            if (onReturnToDashboard) {
              onReturnToDashboard();
            }
          })
          .catch((error) => {
            console.error('API call failed:', error);
            message.error('Failed to submit the form.');
          });
      })
      .catch((info) => {
        console.log('Validation failed:', info);
      });
  };

  useEffect(() => {
    console.log('Form data updated:', formData);
  }, [formData]);

  const clearform = () => {
    form.resetFields();
  };

  const [stepStyle, setStepStyle] = useState({ width: 'auto' });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width < 575) {
        setStepStyle({ width: 'auto' });
      } else if (width < 768) {
        setStepStyle({ width: '100%' });
      } else {
        setStepStyle({ width: 'auto' });
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const steps = [
    {
      title: <div className="step-title">BBS Creation</div>,
      content: (
        <Form form={form} layout="vertical">
          <Row gutter={24}>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Project Name"
                name="project_name"
                rules={[{ required: true, message: 'Please select a project' }]}
              >
                <Select
                  placeholder="select project name"
                  showSearch
                  optionFilterProp="children"
                  className="custom-select"
                  onChange={handleProjectNameChange}
                >
                  {[
                    ...new Set(allProjectList.map((item) => item.project_name)),
                  ].map((projectName, index) => (
                    <Option value={projectName} key={index}>
                      {projectName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={12} xs={24} sm={12}>
              <Form.Item label="Project Code" name="project_id">
                <Select
                  placeholder={
                    isSingleProjectCode
                      ? filteredProjects[0]?.project_code
                      : 'select project code'
                  }
                  showSearch
                  optionFilterProp="children"
                  className="custom-select"
                  disabled={!selectedProjectName || isSingleProjectCode}
                >
                  {filteredProjects.map((filteredItem) => (
                    <Option value={filteredItem.id} key={filteredItem.id}>
                      {filteredItem.project_code}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="SBG"
                name="sbg_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
                <Select
                  placeholder="select SBG"
                  className="custom-select"
                >
                  {bbsList.data.map((item, index) => (
                    <Option value={item.sbg_id} key={index}>
                      {item.sbg_id}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="SBU"
                name="sbu_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
                <Select
                  placeholder="select SBU"
                  className="custom-select"
                >
                  {bbsList.data.map((item, index) => (
                    <Option value={item.sbu_id} key={index}>
                      {item.sbu_id}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="BU"
                name="bu"
                rules={[{ message: 'Please enter the project name' }]}
              >
                <Select
                  placeholder="select BU"
                  className="custom-select"
                >
                  <Select.Option value="project1">Project 1</Select.Option>
                  <Select.Option value="project2">Project 2</Select.Option>
                  <Select.Option value="project3">Project 3</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      ),
    },
  ];
  return (
    <div className="main-div">
      <div className="steps_parent_bbs">
        <Steps
          className="steps_track_bbs"
          style={stepStyle}
          current={currentStep}
          labelPlacement="vertical"
        >
          {steps.map((item, index) => (
            <Step
              key={index}
              icon={
                <img
                  src={step_base_icon}
                  alt="Step Icon"
                  className="step-icon"
                />
              }
              title={
                <div className="step-title-container flex flex-col">
                  <div className="step-title text-blue-800 font-semibold text-sm">
                    {item.title}
                  </div>
                </div>
              }
            />
          ))}
        </Steps>
      </div>

      <div className="step-card flex justify-center items-center">
        <div className="steps_content_parent ">
          <Card>
            <div className="steps-content">
              {steps[currentStep] ? (
                steps[currentStep].content
              ) : (
                <div>No content available</div>
              )}
            </div>
            <div className="steps-action text-center mt-4">
              {currentStep === 0 && (
                <>
                  <Button
                    style={{ margin: '0 2px' }}
                    onClick={onReturnToDashboard}
                    className="prev-button bg-white text-blue-800 rounded-lg px-4 py-2"
                  >
                    Back
                  </Button>
                  <Button
                    style={{ margin: '0 8px' }}
                    onClick={clearform}
                    className="prev-button bg-white text-blue-800 rounded-lg px-4 py-2"
                  >
                    Clear
                  </Button>
                  <Button
                    type="primary"
                    onClick={nextStep}
                    className="next-button bg-blue-800 text-white rounded-lg px-4 py-2"
                  >
                    Create
                  </Button>
                </>
              )}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CreateBBSPage;

// another project code and project name:

{
  /* <Col span={12} xs={24} sm={12}>
<Form.Item
    label="Project Name"
    name="project_name"
    //rules={[{ required: true, message: "Please select a project" }]}
>
    <Select
        placeholder="Select a project"
        showSearch
        optionFilterProp="children"
        className="custom-select"
        onChange={(value) => {
            const matchingProjects = allProjectList.filter(
                (item) => item.project_name === value
            );

            if (matchingProjects.length === 1) {
                // Auto-populate project code if only one match exists
                form.setFieldsValue({ project_id: matchingProjects[0].project_id });
                setIsSingleProjectCode(true);
            } else {
                // Clear the project code if multiple matches exist
                form.setFieldsValue({ project_id: undefined });
                setIsSingleProjectCode(false);
            }

            // Update state
            setSelectedProjectName(value);
            setFilteredProjects(matchingProjects);
        }}
    >
        {/* Display unique project names */
}
//         {[...new Set(allProjectList.map((item) => item.project_name))].map(
//             (projectName, index) => (
//                 <Option value={projectName} key={index}>
//                     {projectName}
//                 </Option>
//             )
//         )}
//     </Select>
// </Form.Item>
// </Col>

// <Col span={12} xs={24} sm={12}>
// <Form.Item
//     label="Project Code"
//     name="project_id"
//     //rules={[{ required: true, message: "Please select the project code" }]}
// >
//     <Select
//         placeholder={
//             filteredProjects?.length === 1
//                 ? filteredProjects[0]?.project_code
//                 : "Select a project code"
//         }
//         showSearch
//         optionFilterProp="children"
//         className="custom-select"
//         disabled={!selectedProjectName || isSingleProjectCode} // Disable if no project selected or has only one code
//     >
//         {/* Show project codes based on selected project name */}
//         {filteredProjects?.map((filteredItem) => (
//             <Option value={filteredItem.project_id} key={filteredItem.project_id}>
//                 {filteredItem.project_code}
//             </Option>
//         ))}
//     </Select>
// </Form.Item>
// </Col> */}
